/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import {
  selectFieldPExecutorEmailConfirm,
  selectFieldPHideForBlackList,
  selectFieldPMinRating
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import {
  changeFieldPExecutorEmailConfirm,
  changeFieldPHideForBlackList,
  changeFieldPMinRating
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import connect from 'react-redux/es/connect/connect';
import DefaultSelect from '../../../Common/Inputs/DefaultSelect/DefaultSelect';

class PerformersTaskInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      p_executor_email_confirm_items: [
        {
          value: 0,
          title: t('Доступно всем исполнителям')
        },
        {
          value: 1,
          title: t('Доступно только для исполнителей с подтвержденной почтой')
        }
      ],
      p_hide_for_black_list_items: [
        {
          value: 0,
          title: t('Разрешить выполнение пользователям из моего ЧС')
        },
        {
          value: 1,
          title: t('Запретить выполнение пользователям из моего ЧС')
        }
      ]
    };
  }

  render() {
    return (
      <React.Fragment>
        <div
          aria-multiselectable="true"
          className="panel-group"
          id="panelGroupUser"
          role="tablist"
        >
          <section className="panel panel-default panel-heading_padding-large panel-body_bg-sub">
            <div className="panel-heading" role="tab">
              <h2 className="panel-title">
                <a
                  aria-controls="filter-collapseConfines_user"
                  aria-expanded="true"
                  className="dropdown-toggle dropdown-toggle-collapse collapsed"
                  data-toggle="collapse"
                  href="#collapseConfines_user"
                  role="button"
                >
                  <i className="fa fa-user-circle-o fa-fw" />{' '}
                  {t('Исполнители – ограничения, лимиты')}
                </a>
              </h2>
            </div>
            <div
              aria-labelledby="headingOne"
              className="panel-collapse collapse"
              id="collapseConfines_user"
              role="tabpanel"
              aria-expanded="true"
            >
              <div className="panel-body">
                <div className="row">
                  <div className="col-xs-24 col-sm-12 col-md-12">
                    <div className="form-group">
                      <label
                        className="control-label"
                        htmlFor="Confines_user_email"
                      >
                        {t('Подтвержденная почта')}
                      </label>
                      <DefaultSelect
                        selectTitleNullValue={null}
                        selectArrItems={
                          this.state.p_executor_email_confirm_items
                        }
                        value={this.props.fieldPExecutorEmailConfirm.value}
                        handleChangeValue={value =>
                          this.props.changeFieldPExecutorEmailConfirm(value)
                        }
                      />
                      <small className="help-block">
                        {t(
                          'Установив эту опцию, ваше задание станет доступно только для исполнителей с подтвержденной почтой'
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="col-xs-24 col-sm-12 col-md-12">
                    <div className="form-group">
                      <label
                        className="control-label"
                        htmlFor="Confines_user_blackList"
                      >
                        {t('Пользователи из черного списка')}
                      </label>
                      <DefaultSelect
                        selectTitleNullValue={null}
                        selectArrItems={this.state.p_hide_for_black_list_items}
                        value={this.props.fieldPHideForBlackList.value}
                        handleChangeValue={value =>
                          this.props.changeFieldPHideForBlackList(value)
                        }
                      />
                      <small className="help-block">
                        {t(
                          'Установив эту опцию, ваше задание станет доступно для исполнителей из вашего черного списка'
                        )}
                      </small>
                    </div>
                  </div>
                  <div className="col-xs-24 col-sm-24 col-md-24">
                    <div className="form-group">
                      <label
                        className="control-label"
                        htmlFor="Confines_user_status"
                      >
                        {t('Рейтинг исполнителя не ниже')}
                      </label>
                      <input
                        className="form-control"
                        placeholder={t('Без ограничений')}
                        type="number"
                        value={this.props.fieldPMinRating.value || ''}
                        onChange={e =>
                          this.props.changeFieldPMinRating(e.target.value)
                        }
                      />
                      <small className="help-block">
                        {t(
                          'Ваше задание будет доступно только для пользователей с реитингом не ниже указанного. Если "0" или поле пустое – ограничений нет (любой пользователь может выполнять ваше задание).'
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

PerformersTaskInputs.propTypes = {
  fieldPExecutorEmailConfirm: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldPHideForBlackList: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldPMinRating: PropTypes.shape({
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  changeFieldPExecutorEmailConfirm: PropTypes.func.isRequired,
  changeFieldPHideForBlackList: PropTypes.func.isRequired,
  changeFieldPMinRating: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  fieldPExecutorEmailConfirm: selectFieldPExecutorEmailConfirm(
    state,
    props.reducerName
  ),
  fieldPHideForBlackList: selectFieldPHideForBlackList(
    state,
    props.reducerName
  ),
  fieldPMinRating: selectFieldPMinRating(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldPExecutorEmailConfirm: value =>
    dispatch(changeFieldPExecutorEmailConfirm(props.reducerName, value)),
  changeFieldPHideForBlackList: value =>
    dispatch(changeFieldPHideForBlackList(props.reducerName, value)),
  changeFieldPMinRating: value =>
    dispatch(changeFieldPMinRating(props.reducerName, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformersTaskInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/PerformersTaskInputs/PerformersTaskInputs.js